import React from "react";
import {
  Box,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TableContainer,
  IconButton,
  Button,
} from "@mui/material";
import Grid from "@mui/material/Grid2";
import moment from "moment";
import PulseLoader from "react-spinners/PulseLoader";

const DetailList = ({
  productList,
  setProductList,
  handleDialogClose,
  loading,
  onSubmit,
  readOnly,
  height,
}) => {
  return (
    <Box
      sx={{
        mt: 1,
        background: "#fff",
        border: "1px solid #EAECF1",
        borderRadius: "12px",
        overflow: "hidden",
        padding: "16px 0",
        boxShadow: "0px 1px 2px 0px rgba(15, 22, 36, 0.05)",
      }}
    >
      <Grid
        container
        justifyContent="space-between"
        alignItems="center"
        sx={{ px: 1.5, mb: 1.75 }}
      >
        <Grid size={{ xs: 12, sm: 12, md: 12, lg: 2, xl: 2 }}>
          <Typography
            variant="h6"
            gutterBottom
            component="div"
            sx={{ color: "#0F1624", fontWeight: 600, margin: 0 }}
            onClick={() => {
              console.log("productList", productList);
            }}
          >
            List ({productList?.length})
          </Typography>
        </Grid>
      </Grid>
      <div
        style={{
          overflowX: "auto",

          minWidth: "100%",
          width: "Calc(100vw - 385px)",

          // padding: "10px 16px 0px",
          boxSizing: "border-box",
        }}
      >
        <TableContainer
          sx={{ height: height ? height : "Calc(100vh - 590px)" }}
        >
          <Table stickyHeader aria-label="sticky table">
            <TableHead>
              <TableRow>
                <TableCell style={{ whiteSpace: "nowrap" }}>
                  Product Name
                </TableCell>
                <TableCell style={{ whiteSpace: "nowrap" }}>
                  Purchase date
                </TableCell>
                <TableCell style={{ whiteSpace: "nowrap" }}>Branch</TableCell>

                {/* <TableCell style={{ whiteSpace: "nowrap" }}>
                  Purchase price
                </TableCell> */}
                <TableCell style={{ whiteSpace: "nowrap" }}>
                  SKU Number
                </TableCell>
                {/* <TableCell style={{ whiteSpace: "nowrap" }}>Note</TableCell> */}
                {/* <TableCell style={{ whiteSpace: "nowrap" }}>Device</TableCell>
                  <TableCell style={{ whiteSpace: "nowrap" }}>Model</TableCell>

                  <TableCell style={{ whiteSpace: "nowrap" }}>Price</TableCell>
                  <TableCell style={{ whiteSpace: "nowrap" }}>
                    Warranty
                  </TableCell>
                 
                  <TableCell style={{ whiteSpace: "nowrap" }}>
                    Serial No
                  </TableCell>
                  <TableCell style={{ whiteSpace: "nowrap" }}>
                    Description
                  </TableCell>
                  <TableCell style={{ whiteSpace: "nowrap" }}>Note</TableCell>
                 {/* <TableCell style={{ whiteSpace: "nowrap" }}>Status</TableCell>*/}

                {/* {!readOnly && (
                  <TableCell align="right" style={{ whiteSpace: "nowrap" }}>
                    Actions
                  </TableCell>
                )} */}
              </TableRow>
            </TableHead>
            <TableBody>
              {productList.length > 0 &&
                productList.map((row, i) => (
                  <TableRow
                    key={i}
                    // sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                  >
                    {/* <TableCell sx={{ width: 50 }}>
                        <img
                          src={
                            row?.images?.length > 0
                              ? row?.images[0]?.url
                              : "/noImage.jpg"
                          }
                          alt=""
                          width={40}
                        />
                      </TableCell> */}
                    <TableCell sx={{ minWidth: "130px" }}>
                      {row?.product_data
                        ? row?.product_data[0]?.name
                        : "---------"}{" "}
                      &nbsp;{" "}
                      {row?.product_variation_data
                        ? row?.product_variation_data[0]?.name
                        : "---------"}
                    </TableCell>

                    <TableCell>
                      {moment(row?.purchase_data[0]?.purchase_date).format(
                        "DD/MM/YYYY",
                      )}
                    </TableCell>
                    <TableCell>
                      {row?.branch_data
                        ? row?.branch_data[0]?.name
                        : "---------"}
                    </TableCell>
                    {/* <TableCell sx={{ minWidth: "130px" }}>
                      {row?.purchase_products_data
                        ? row?.purchase_products_data[0]?.unit_price
                        : "---------"}
                    </TableCell> */}
                    <TableCell>{row?.sku_number}</TableCell>
                    {/* <TableCell>
                        {" "}
                        <TextField
                          required
                          size="small"
                          id="name"
                          placeholder="Enter Note"
                          variant="outlined"
                          sx={{
                            ...customeTextFeild,
                            "& .MuiOutlinedInput-input": {
                              padding: "6.5px 12px",
                              fontSize: "14px",
                            },
                            minWidth: "150px",
                          }}
                          value={row?.note || ""}
                          onChange={(e) => {
                            const updatedRows = [...productList];
                            updatedRows[i].note = e.target.value;
                            setProductList(updatedRows);
                          }}
                        />
                      </TableCell> */}
                    {/* {!readOnly && (
                      <TableCell align="right">
                        <IconButton
                          onClick={() =>
                            setProductList(
                              productList?.filter(
                                (res) => res.sku_number !== row?.sku_number,
                              ),
                            )
                          }
                        >
                          <svg
                            width="20"
                            height="20"
                            viewBox="0 0 20 20"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M12.2837 7.5L11.9952 15M8.00481 15L7.71635 7.5M16.023 4.82547C16.308 4.86851 16.592 4.91456 16.875 4.96358M16.023 4.82547L15.1332 16.3938C15.058 17.3707 14.2434 18.125 13.2637 18.125H6.73631C5.75655 18.125 4.94198 17.3707 4.86683 16.3938L3.97696 4.82547M16.023 4.82547C15.0677 4.6812 14.1013 4.57071 13.125 4.49527M3.125 4.96358C3.40798 4.91456 3.69198 4.86851 3.97696 4.82547M3.97696 4.82547C4.93231 4.6812 5.89874 4.57071 6.875 4.49527M13.125 4.49527V3.73182C13.125 2.74902 12.3661 1.92853 11.3838 1.8971C10.9244 1.8824 10.463 1.875 10 1.875C9.53696 1.875 9.07565 1.8824 8.61618 1.8971C7.63388 1.92853 6.875 2.74902 6.875 3.73182V4.49527M13.125 4.49527C12.0938 4.41558 11.0516 4.375 10 4.375C8.94836 4.375 7.9062 4.41558 6.875 4.49527"
                              stroke="#4A5468"
                              strokeWidth="1.5"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                          </svg>
                        </IconButton>
                      </TableCell>
                    )} */}
                  </TableRow>
                ))}
            </TableBody>
          </Table>
        </TableContainer>
        {!readOnly && (
          <Box
            sx={{
              px: 2,
              pt: 1,
              textAlign: "right",
              borderTop: "1px solid #EAECF0",
            }}
          >
            <Button
              variant="outlined"
              onClick={handleDialogClose}
              sx={{
                px: 2,
                py: 1.25,
                fontSize: "14px",
                fontWeight: 600,
                color: "#344054",
                border: "1px solid #D0D5DD",
                boxShadow: "0px 1px 2px 0px rgba(16, 24, 40, 0.05)",
              }}
            >
              Cancel
            </Button>
            &nbsp;
            <Button
              variant="contained"
              disabled={loading}
              type="submit"
              sx={{
                px: 2,
                py: 1.25,
                fontSize: "14px",
                fontWeight: 600,
                minWidth: "127px",
                minHeight: "44px",
              }}
              // style={{ minWidth: "180px", minHeight: "35px" }}

              disableElevation
              onClick={onSubmit}
            >
              <PulseLoader
                color={"#4B46E5"}
                loading={loading}
                size={10}
                speedMultiplier={0.5}
              />{" "}
              {loading === false && "Submit"}
            </Button>
          </Box>
        )}
      </div>
    </Box>
  );
};

export default DetailList;
